import { utils } from 'ethers';
import {computed, makeAutoObservable, observable} from 'mobx';
import { contractAddresses, tokenDecimals } from '../helpers/config/contracts.config';
import apiService from "../services/api/api.service";
import { IAccountBalance } from '../services/api/api.interfaces';


const convertUsdtBalanceToDecimal = (balance: string) => {
    return Number(utils.formatUnits(balance, tokenDecimals.usdt)) + '';
}

class BalanceStore {
    latestBlock = 0;
    usdtTokenBalance = '0';
    usdtAvailableBalance = '0';

    get usdtAvailableBalanceDecimal() {
        return convertUsdtBalanceToDecimal(this.usdtAvailableBalance);
    }
    get usdtTokenBalanceDecimal() {
        return convertUsdtBalanceToDecimal(this.usdtTokenBalance);
    }

    constructor() {
        makeAutoObservable(this, {
            usdtAvailableBalance: observable,
            latestBlock: observable,
            usdtTokenBalance: observable,
            usdtAvailableBalanceDecimal: computed,
            usdtTokenBalanceDecimal: computed,
        });
    }

    public setUsdtAvailableBalance(newBalance: IAccountBalance) {
        this.usdtAvailableBalance = newBalance.availableBalance;
    }

    public resetUsdtAvailableBalance() {
        this.usdtAvailableBalance = '0';
    }

    public resetState() {
        this.usdtTokenBalance = '0';
        this.usdtAvailableBalance = '0';
    }

    setUsdtTokenBalanceDecimal(newBalance: string) {
        this.usdtTokenBalance = newBalance;
    }

    setLatestBlock(newBlock: number) {
        this.latestBlock = newBlock;
    }

    async fetchBalance(userAddress: string) {
        try {
            const balances = await apiService.accountsBalancesGet({user: userAddress});
            const usdtBalance = balances.find((a: IAccountBalance) => a.token.toLowerCase() ===  contractAddresses.polygon.usdt.toLowerCase())
            if (usdtBalance) {
                this.setUsdtAvailableBalance(usdtBalance)
            } else {
                this.resetUsdtAvailableBalance()
            }
        } catch (error) {
            console.error('Failed to fetch balances:', error);
        }
    }

    async fetchTokenBalance(usdtContract: any, address: string, blockNumber: number) {
        if (usdtContract && blockNumber - this.latestBlock > 1) {
            const balance = await usdtContract.read.balanceOf([address]);
            this.setUsdtTokenBalanceDecimal(balance.toString());
            this.setLatestBlock(blockNumber);
        }
    }
}

export const balanceStore = new BalanceStore();
